import { render, staticRenderFns } from "./BaseBreadcrumb.vue?vue&type=template&id=2ad1655f"
import script from "./BaseBreadcrumb.vue?vue&type=script&lang=js"
export * from "./BaseBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports